import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MedclassButtonComponent} from "../medclass-button/medclass-button.component";
import { CentralService } from "../../../services/central.service";
import { image } from 'ngx-editor/schema/nodes';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-onboarding',
  standalone: true,
  imports: [MedclassButtonComponent,CommonModule],
  templateUrl: './onboarding.component.html',
  styleUrl: './onboarding.component.css'
})
export class OnboardingComponent implements OnInit{

  @Output() cerrarOnboarding = new EventEmitter<boolean>();
  @Input() usuario:string = '';   
  @Input() id_usuario:string = '';
  
  constructor(
    private authService:CentralService,
    private router: Router){
    
  }

  ngOnInit(): void {

    this.onboardingCardArray=[
      {
        title: `Bienvenido, ${this.usuario}`,
        descripcion: 'Descubre todo lo que MedClass puede ofrecerte.',
        img: 'onBoarding1.png'
      },
      {
        title: 'Rienda suelta a tu aprendizaje',
        descripcion: 'Da continuidad a los cursos que iniciaste en cualquier momento.',
        img: 'onboarding2.gif'
      },
      {
        title: 'Explora nuestras Masterclasses',
        descripcion: 'Accede a una diversidad de contenidos estructurados por área terapéutica.',
        img: 'onboarding3.gif'
      },
      {
        title: 'Sesiones y retransmisiones',
        descripcion: 'Únete a las sesiones en vivo o reproduce las retransmisiones de los eventos realizados.',
        img: 'onboarding4.gif'
      },
      {
        title: 'Podcast',
        descripcion: 'Consulta nuestros podcast médicos con temas de interés.',
        img: 'onboarding5.gif'
      }
    ];
    
  }


  index:number = 0;

  onboardingCardArray:any[] = [];

  retrocederOnboarding(){
    this.index--
    console.log(this.usuario);
    
  }

  avanzarOnboarding(){
    if (this.index + 1 == this.onboardingCardArray.length ) {
      return
      
    }else{
      this.index++
    } 
  }

  finalizarOnBoarding(){
    this.cerrarOnboarding.emit(false);
    this.authService.actualizaCampoOnboarding(this.id_usuario).subscribe((res:any)=>{
      console.log(res);
    });
  }

}
